<script setup lang="ts">
import type { PropType } from "vue";

const props = defineProps({
  name: { type: String as PropType<string>, required: true },
  type: {
    type: String as PropType<"outlined" | "filled" | "rounded" | "flag" | undefined>,
    default: "outlined",
  },
});

const iconHref = `/icons/sprite.svg?v=${import.meta.env.VITE_VERSION}#${props.name}-${props.type}`;
</script>

<template>
  <svg role="img" class="fill-current" aria-hidden="true">
    <use :href="iconHref" />
  </svg>
</template>
